import { Navigate, useParams } from 'react-router-dom'

/** Legacy create URL → map with profile modal open in create mode. */
export function CreateBiddleRedirect() {
  const { propertyId } = useParams<{ propertyId: string }>()
  if (!propertyId) return <Navigate to="/map" replace />
  return (
    <Navigate
      to={`/map?property=${encodeURIComponent(propertyId)}&create=1`}
      replace
    />
  )
}
